
import ReactImg from ".././assets/react12.png"
import NodeImg from ".././assets/nodejs1.png"
import ExpressImg from ".././assets/express3.png"
import MongoImg from ".././assets/mongo.png"
import MongooseImg from ".././assets/mongoose.png"
import HttpImg from ".././assets/http.png"
import HTMLImg from ".././assets/html1.png"
import CSSImg from ".././assets/css.png"
import BootstrapImg from ".././assets/bootstrap.png"
import JSImg from ".././assets/js.png"
import JavaImg from ".././assets/java.png"
import SpringImg from ".././assets/spring.png"
import RestImg from ".././assets/rest.png"
import GitImg from ".././assets/git.png"
import PostmanImg from ".././assets/postman1.png"

const skillsData=[
    {
        skillImg:ReactImg,
        skillName:"React"
    },
    {
        skillImg:NodeImg,
        skillName:"Node.js"
    },
    {
        skillImg:ExpressImg,
        skillName:"Express.js"
    },
    {
        skillImg:MongoImg,
        skillName:"MongoDB"
    },
    {
        skillImg:MongooseImg,
        skillName:"Mongoose"
    },
    {
        skillImg:HttpImg,
        skillName:"HTTP"
    },
    {
        skillImg:HTMLImg,
        skillName:"HTML"
    },
    {
        skillImg:CSSImg,
        skillName:"CSS"
    },
    {
        skillImg:BootstrapImg,
        skillName:"BootStrap"
    },
    {
        skillImg:JSImg,
        skillName:"JavaScript"
    },

    {
        skillImg:JavaImg,
        skillName:"Java"
    },

    {
        skillImg:SpringImg,
        skillName:"SpringBoot"
    },

    {
        skillImg:RestImg,
        skillName:"Rest"
    },

    {
        skillImg:GitImg,
        skillName:"Git & Github"
    },

    // {
    //     skillImg:PostmanImg,
    //     skillName:"PostMan"
    // },
    
]

export default skillsData;